<template>
  <div class="light-spot-mix">
    <div class="mix-item" v-for="(item,index) in lightSpots" :key="index">
      <img :src="item.headPhoto">
      <h3>{{item.kind}}</h3>
      <h1>
        <p v-for="(paragraph,i) in item.title" :key="i">
          {{paragraph}}
        </p>
      </h1>
      <p>
        {{item.paragraph}}
      </p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'LightSpotMix',
    computed: {
      ...mapState({
        lightSpots: state => state.LightSpotMix,
      })
    }
  };
</script>

<style scoped lang="less">
  .light-spot-mix {
    display: flex;
    justify-content: space-between;
    height: 100vh;
    margin-left: 5vh;

    .mix-item {
      width: 70vh;

      &:not(:first-of-type) {
        margin-left: 1vh;
      }

      img {
        width: 100%;
      }


      h3 {
        margin-top: 2vh;
        color: #ff3c00;
        font-size: 2vh;
      }

      h1 {
        margin-top: 0.8vh;
        height: 12vh;
        font-size: 3.5vh;
      }

      > p {
        width: 90%;
        line-height: 1.5;
        text-align: justify;
        font-size: 2vh;
        font-weight: 100;
      }

    }
  }
</style>
